import React from "react";
import { Spinner } from "reactstrap";

function RouteSuspenseFallback() {
  return (
    <div
      className="route-suspense-fallback"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40vh",
        width: "100%",
      }}
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner style={{ height: "3rem", width: "3rem" }} color="info">
        Loading...
      </Spinner>
    </div>
  );
}

export default RouteSuspenseFallback;
